var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheckMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_287_6880)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0802 0.836792C9.09453 0.836792 7.15361 1.42555 5.5028 2.52859C3.85199 3.63164 2.56502 5.19963 1.80526 7.03387C1.0455 8.86822 0.846486 10.8867 1.23392 12.8342C1.62126 14.7815 2.57743 16.5703 3.98124 17.9741C5.38549 19.3782 7.17414 20.3341 9.12164 20.7216C11.0691 21.109 13.0873 20.9101 14.922 20.1503C16.7562 19.3906 18.3238 18.1039 19.4269 16.4529C20.53 14.802 21.1188 12.8611 21.1188 10.8756C21.1159 8.21418 20.0568 5.66236 18.1751 3.78053C16.2932 1.89859 13.7418 0.840026 11.0802 0.836792ZM11.0802 19.0892C9.45546 19.0892 7.86775 18.6077 6.51655 17.705C5.16604 16.8025 4.11356 15.5196 3.49163 14.0189C2.87017 12.518 2.70738 10.8666 3.02404 9.27323C3.34127 7.67994 4.1236 6.21638 5.27228 5.0677C6.42094 3.91892 7.88424 3.13667 9.47746 2.8197C11.0712 2.50283 12.7225 2.6656 14.2234 3.28718C15.7239 3.90886 17.0067 4.96165 17.9094 6.31237C18.812 7.66307 19.2936 9.25116 19.2936 10.8756C19.2911 13.0533 18.4251 15.1411 16.885 16.681C15.3454 18.2207 13.2576 19.0869 11.0802 19.0892Z",
    fill: "#20A93F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32812 11.25L10.3281 13.75L14.8281 8.25",
    stroke: "#20A93F",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_6880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.455078 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckMarkIcon);
export default __webpack_public_path__ + "static/media/circleCheckMarkIcon.7a0919ac240f0d6847da0da555ba96ab.svg";
export { ForwardRef as ReactComponent };